import { Alert, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { INCOMING_MAIL_STATUSES } from "src/utils/constants/constants";
import { Props, State } from "./interfaces";
import { SaveResponse } from "../../models/api/save";
import { IncomingMailApiService } from "../../services/incoming-mail/incoming-mail-api.service";
import { OutgoingMailApiService } from "../../services/outgoing-mail/outgoing-mail-api.service";
import DialogActions from "../DialogActions/DialogActions";
import DialogTitle from "../DialogTitle/DialogTitle";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

const DeleteMail = ({ outgoingMail, incomingMail, handleNotifyParent }: Props) => {
  const tRP = "components.delete_mail";
  const { t } = useTranslation();
  const theme = useTheme();

  const INITIAL_STATE: State = useMemo(
    () => ({
      open: false,
      loading: false,
      CCDOpen: false,
      error: "",
    }),
    []
  );

  const [state, setState] = useState<State>({
    ...INITIAL_STATE,
  });

  //#region delete
  const handleDelete = useCallback(async () => {
    setState((state) => ({ ...state, loading: true }));
    try {
      let response: SaveResponse | null = null;
      if (incomingMail) {
        response = await new IncomingMailApiService().saveItems([
          {
            ...incomingMail,
            isDeleted: true,
            doNotProcessByOcr: false,
          },
        ]);
      } else if (outgoingMail) {
        response = await new OutgoingMailApiService().saveItems([
          {
            ...outgoingMail,
            isDeleted: true,
            doNotProcessByOcr: false,
          },
        ]);
      }

      if (response?.error) {
        setState((state) => ({ ...state, error: response?.error ?? "" }));
      } else {
        setState({ ...INITIAL_STATE });
        handleNotifyParent();
      }
    } catch (error) {
      setState((state) => ({ ...state, error: error as string }));
    } finally {
      setState((state) => ({ ...state, loading: false }));
    }
  }, [INITIAL_STATE, handleNotifyParent, incomingMail, outgoingMail]);
  //#ednregion
  return (
    <>
      <Button
        onClick={() => setState((state) => ({ ...state, open: true }))}
        title={`${t(`${tRP}.button_title`)}`}
        style={{
          color:
            incomingMail?.status?.id === INCOMING_MAIL_STATUSES.Emailed.id
              ? theme.palette.secondary.light
              : theme.palette.error.main,
        }}
        disabled={incomingMail?.status?.id === INCOMING_MAIL_STATUSES.Emailed.id}
      >{`${t(`${tRP}.button_title`)}`}</Button>
      <Dialog
        open={state.open}
        fullWidth
      >
        <DialogTitle
          title={`${t(`${tRP}.title`)}`}
          handleClose={() => setState((state) => ({ ...state, open: false }))}
        />
        <DialogContent>
          <LoadingOverlay
            loading={state.loading}
            error={state.error}
          >
            <Alert severity="error">{`${t(`${tRP}.info`)}`}</Alert>
          </LoadingOverlay>
        </DialogContent>
        <DialogActions
          handleCancel={() => setState((state) => ({ ...state, open: false }))}
          handleSave={handleDelete}
          customSaveName={`${t(`${tRP}.yes_delete`)}`}
          customSaveStyle={{ backgroundColor: theme.palette.error.main }}
        />
      </Dialog>
    </>
  );
};

export default DeleteMail;
